module.exports = ".email {\n  white-space: pre-wrap; }\n"